$(function() {
  $('[data-toggle="menu-sidebar"]').on('click', function(e) {
    e.preventDefault();

    $('body').toggleClass('menu-sidebar-opened');
  });

  $('.menu-sidebar .item-sub .collapse').on('show.bs.collapse', function(e) {
    $(e.target)
      .parent()
      .addClass('opened');
  });

  $('.menu-sidebar .item-sub .collapse').on('hide.bs.collapse', function(e) {
    $(e.target)
      .parent()
      .removeClass('opened');
  });
});
